<div class="edit-account-root">
  <div class="edit-account-header">
    <div class="user-header-info">
      <div class="user-info">
        <div class="name">
          {{ meterReading?.firstName | hasValue }} {{ meterReading?.surname | hasValue}}
        </div>

        <div class="application-number">
          {{ meterReading?.accountNumber }}
        </div>

        <div class="edit-accounts-body row">
          <div class="col-12">
            <div class="row">
              <div [ngClass]="{ 'col-4': meterReading?.status, 'col-12': !meterReading?.status }">
                <div class="entry-status" [ngClass]="meterReading?.status | getReadingStatusClass">
                  <!-- Change background and text color in .scss file -->
                  {{meterReading?.status | getReadingStatusClass:true | translate}}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="action-buttons" *ngIf="this.meterReading?.status == 'Failed'">
      <button class="btn btn-header" data-bs-toggle="modal" data-bs-target="#updateStatus">
        {{'COMMON.UPDATE_STATUS' | translate }}
      </button>
    </div>
  </div>
  <div class="edit-accounts-body row">
    <div class="col-4">
      <div class="row">

        <app-reading-text-box [items]="buildingInformation" [header]="'READING.DETAILS.BUILDING_INFORMATION' | translate"></app-reading-text-box>
        <app-reading-text-box *ngIf="meterReading?.priority" [items]="priorityStatus"
          [header]="'READING.PRIORITY_STATUS' | translate"></app-reading-text-box>
        <app-reading-text-box [items]="readingInformation" [header]="'READING.DETAILS.READING_INFORMATION' | translate"></app-reading-text-box>

      </div>
    </div>
    <div class="col-4">
      <div class="row">

        <app-reading-text-box [items]="accountInformation"  [header]="'READING.DETAILS.ACCOUNT_INFORMATION' | translate"></app-reading-text-box>
        <app-reading-text-box [items]="meterInformation" [header]="'READING.DETAILS.METER_INFOMRATION' | translate"></app-reading-text-box>
        <app-reading-text-box [items]="inaccessible" [header]="'READING.DETAILS.INACCESSIBLE' | translate"
          *ngIf="meterReading?.status == ReadingStatus[ReadingStatus.Inaccessible]"></app-reading-text-box>
        <app-reading-text-box [items]="inoperableMeter" [header]="'READING.DETAILS.INOPERABLE' | translate"
          *ngIf="meterReading?.status == ReadingStatus[ReadingStatus.Inoperable]"></app-reading-text-box>

      </div>
    </div>

    <div class="image-container col-4">
      <div class="card container">
        <div [ngSwitch]="meterReading?.status">
          <div *ngSwitchCase="ReadingStatus[ReadingStatus.Assigned]">{{ 'READING.DETAILS.PICTURE_OF_METER_READING' | translate}}</div>
          <div *ngSwitchCase="ReadingStatus[ReadingStatus.Submitted]">{{ 'READING.DETAILS.PICTURE_OF_METER_READING' | translate}}</div>
          <div *ngSwitchCase="ReadingStatus[ReadingStatus.Failed]">{{ 'READING.DETAILS.PICTURE_OF_METER_READING' | translate}}</div>
          <div *ngSwitchCase="ReadingStatus[ReadingStatus.Rejected]">{{ 'READING.DETAILS.PICTURE_OF_METER_READING' | translate}}</div>
          <div *ngSwitchCase="ReadingStatus[ReadingStatus.Inaccessible]">{{ 'READING.DETAILS.PICTURE_OF_SUPPLY_CABLE' | translate}}</div>
          <div *ngSwitchCase="ReadingStatus[ReadingStatus.Inoperable]">{{ 'READING.DETAILS.PICTURE_OF_METER' | translate}}</div>
        </div>
        <div class="images-list">
          <div>
            <img *ngIf="meterReading?.imageUrl; else noImage" src="{{ meterReading?.imageUrl }}"
              (click)="showImage(meterReading?.image)" data-bs-toggle="modal" data-bs-target="#modalImage"
              alt="Item image" />
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="modal modalMap" id="showImageMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-building-map [setMapVisibility]="isImageMapVisible" [longitude]="selectedImage?.longitude"
          [latitude]="selectedImage?.latitude"></app-building-map>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalImage" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()"
  (shown.bs.modal)="onModalOpen()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modal-image">
      <div class="modal-body modal-body-image">
        <div class="image-container" [style.transform]="'rotate(' + currentRotation + 'deg)'">
          <lib-ngx-image-zoom [zoomMode]="'hover-freeze'" [fullImage]="selectedImage?.url" [thumbImage]="selectedImage?.url"
            [magnification]="3">
          </lib-ngx-image-zoom>
        </div>
        <div class="rotate-div">
          <button class="btn btn-primary left-button" (click)="rotateLeft()">
            &lt;
          </button>
          <button class="btn btn-primary right-button" (click)="rotateRight()">
            &gt;
          </button>
        </div>
        <app-image-geo-info [image]="selectedImage"
          (mapClicked)="isImageMapVisible = !isImageMapVisible"></app-image-geo-info>
      </div>
    </div>
  </div>
</div>

<ng-template #noImage>
  <img class="no-image" src="{{ placeholderImage }}" alt="Placeholder image" />
</ng-template>

<div class="modal" id="updateStatus" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="cancelModal()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'COMMON.UPDATE_STATUS' | translate }}</h5>
        <button type="button" #closeDQModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close"
          (click)="cancelModal()">
          {{ 'READING.CANCEL' | translate }}
        </button>
      </div>
      <div class="modal-body">
        <div class="form-item form-floating mb-3">
          <select class="form-select" (change)="onOptionSelected($event)">
            <option name="answer" ngDefaultControl *ngFor="let option of failedReadingOptions" [value]="option.key">
              {{ option.value | translate }}
            </option>
          </select>
        </div>
        <div class="form-item form-floating mb-3" *ngIf="selectedFailedReadingOption === 3">
          <select class="form-select" (change)="onRetakeOptionSelected($event)">
            <option name="answer" ngDefaultControl *ngFor="let option of retakeOptions" [value]="option.key">
              {{ option.value | translate }}
            </option>
          </select>
        </div>
        <div class="form-floating form-item" *ngIf="selectedFailedReadingOption === 3 && selectedRetakeOption === 2">
          <input type="text" name="filterText" [(ngModel)]="filterText" class="form-control filter-field"
            [ngClass]="{ 'valid-input': tempAssignedUserId != 0 }" id="floatingInput"
            (ngModelChange)="filterMobileUsers()" placeholder=" " />
          <label for="floatingInput">{{'COMMON.FIELD_AGENT' | translate}}</label>

          <div class="filtered-agent-list" *ngIf="filterText && filterText.length > 2 && isDropdownOpened"
            #dropdownContainer>
            <div click-stop-propagation class="agent-name" (click)="selectFieldAgent(u.id)"
              *ngFor="let u of mobileUsers">
              {{ u.firstName }} {{ u.lastName }}
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="btn btn-primary" (click)="updateReading()">
            {{'COMMON.SUBMIT' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>